import React, { useEffect, useMemo, useState,useRef } from "react";
import "./Timer.css";
import useAppHooks from "../../hooks/useAppHooks";
import { setTimeLeft ,updateQuestionTime } from "../../../redux/exam/examSlice";

const Timer = () => {
  const { dispatch, selector } = useAppHooks();

  const examState = selector((state) => state?.examSlice?.questionsList);

  const paperDuration = examState?.paper_duration || 10800;
  const totalTime = examState?.total_time || 0;
  const timeStatus = examState?.time_status || {};

  // Read time from redux
  const timeLeft = selector((state) => state?.examSlice?.timeLeft);
   const submitResult = selector((state) => state.examSlice.submitResult);
const currentQuestionIndex = selector((state) => state.examSlice.currentQuestionIndex);
const questionsData = selector((state) => state.examSlice.questionsData);
  // const timeRef = useRef(timeLeft);
  const [toast, setToast] = useState(null);

  // Initialize time only once
//  useEffect(() => {
//   if (timeLeft == null || timeLeft <= 0) {
//     dispatch(setTimeLeft(paperDuration)); // start fresh
//   }
// }, [timeLeft, dispatch, paperDuration]);
  // useEffect(() => {
  //   timeRef.current = timeLeft;
  // }, [timeLeft]);sas
// Stop timer after submission
// useEffect(() => {
//   if (submitResult) {
//     dispatch(setTimeLeft(0)); // stop the timer
//     localStorage.removeItem("exam_timeLeft");
//     localStorage.removeItem("exam_testId");
//   }
// }, [submitResult, dispatch]);

// useEffect(() => {
//   if (timeLeft === null) return;

//   const interval = setInterval(() => {
//   if (timeRef.current === null || timeRef.current <= 0) return;


//     const newTime = timeRef.current - 1;

//     dispatch(setTimeLeft(newTime));
//     dispatch(updateQuestionTime({ index: currentQuestionIndex }));
//     localStorage.setItem("exam_timeLeft", newTime.toString());
//   }, 1000);

//   return () => clearInterval(interval);
// }, [timeLeft, currentQuestionIndex, dispatch]);sasi
useEffect(() => {
  if (submitResult) return;
  if (timeLeft === null) return;   // allow fresh init
if (timeLeft <= 0) return;

  const interval = setInterval(() => {
    const next = timeLeft - 1;

    if (next <= 0) {
      dispatch(setTimeLeft(0));
      localStorage.removeItem("exam_timeLeft");
    } else {
      dispatch(setTimeLeft(next));
      localStorage.setItem("exam_timeLeft", String(next));
    }

    dispatch(updateQuestionTime({ index: currentQuestionIndex }));
  }, 1000);

  return () => clearInterval(interval);
}, [timeLeft, submitResult, currentQuestionIndex, dispatch]);




  // Run timer interval only once
  // useEffect(() => {
  //   if (timeLeft <= 0) return;

  //   const interval = setInterval(() => {
  //     dispatch(setTimeLeft(Math.max(timeLeft - 1, 0)));
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [timeLeft, dispatch]);



  // Toast trigger logic
  useEffect(() => {
    const checkToast = (status) => {
      if (status?.toast_time && timeLeft === status.toast_time) {
        setToast({
          text: status.toast_text,
          bgColor: status.toast_bg_color,
          textColor: status.toast_text_color,
        });

        setTimeout(() => setToast(null), 5000);
      }
    };

    checkToast(timeStatus.second);
    checkToast(timeStatus.third);
  }, [timeLeft, timeStatus]);

  // Time formatting
  const formattedTime = useMemo(() => {
    if (!timeLeft && timeLeft !== 0) return "";
    const hrs = Math.floor(timeLeft / 3600);
    const mins = Math.floor((timeLeft % 3600) / 60);
    const secs = timeLeft % 60;
    return [hrs, mins, secs].map((t) => String(t).padStart(2, "0")).join(":");
  }, [timeLeft]);

  // Dynamic color based on percentage
  const timerStyle = useMemo(() => {
    const percentLeft = (timeLeft / paperDuration) * 100;

    if (percentLeft > 60)
      return { backgroundColor: timeStatus.first?.bg_color, color: timeStatus.first?.text_color };

    if (percentLeft > 20)
      return { backgroundColor: timeStatus.second?.bg_color, color: timeStatus.second?.text_color };

    return { backgroundColor: timeStatus.third?.bg_color, color: timeStatus.third?.text_color };  
  }, [timeLeft, paperDuration, timeStatus]);

  return (
    <div className="timer-container">
      <div className="timer-box" style={timerStyle}>
        <p>{timeLeft > 0 ? formattedTime : "00:00:00"}</p>
      </div>

      {toast && (
        <div className="toast-box" style={{ ...toast, marginTop: "8px", padding: "6px 12px", borderRadius: "6px", fontWeight: 500 }}>
          {toast.text}
        </div>
      )}
    </div>
  );
};

export default Timer;
